import { render } from "./ImplantsToApply.vue?vue&type=template&id=907681dc&scoped=true"
import script from "./ImplantsToApply.vue?vue&type=script&lang=js"
export * from "./ImplantsToApply.vue?vue&type=script&lang=js"

import "./ImplantsToApply.vue?vue&type=style&index=0&id=907681dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-907681dc"]])

export default __exports__